import { Map } from "common/utils/Map/types";
import {
  Polyline,
  PolylineOptions
} from '../../types';

export class GooglePolyline implements Polyline {
  private _polyline?: google.maps.Polyline;

  constructor(map: Map, options?: PolylineOptions) {
    this._createPolyline(options);
    this._addPolylineOnMap(map);
  }

  _createPolyline(options?: PolylineOptions) {
    this._polyline = new google.maps.Polyline(options);
  }

  _addPolylineOnMap(map: Map) {
    const nativeMap = map.getNativeMap();

    if (this._polyline && nativeMap) {
      this._polyline.setMap(nativeMap);
    }
  }

  delete() {
    if (this._polyline) {
      this._polyline.setMap(null);
    }
  }
}
